export default function InfoCallout({ children }: { children: React.ReactNode }) {
  return (
    <div
      className="my-8 overflow-hidden rounded-2xl border px-7 py-6"
      style={{
        borderColor: "rgba(0,229,179,0.15)",
        background: "linear-gradient(135deg, rgba(0,229,179,0.05) 0%, rgba(0,153,255,0.03) 100%)",
      }}
    >
      {children}
    </div>
  );
}
